"use client"

import React from "react"
import Image from "next/image"

export function AppLoadingShell() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 text-foreground flex items-center justify-center fixed inset-0 z-[9999]">
      <div className="text-center space-y-6">
        <div className="w-20 h-20 flex items-center justify-center mx-auto animate-pulse">
          <Image src="/spotstosurf-transparant.png" alt="Loading" width={80} height={80} className="object-contain" />
        </div>
        <div className="flex flex-col items-center gap-2">
          <div className="h-1 w-32 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
            <div className="h-full bg-blue-600 animate-progress origin-left w-full" />
          </div>
          <p className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">
            Initializing...
          </p>
        </div>
      </div>
    </div>
  )
}
